export default __webpack_public_path__ + "static/forecasting-bg-7c369f3de0f3baf7b7d40bd8055885c1.jpg";